(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const yenFormatter = new Intl.NumberFormat('ja-JP');

    const isWithinRange = (hour, start, end) => {
      if (start === end) return false;
      return start < end ? hour >= start && hour < end : hour >= start || hour < end;
    };

    const readHour = (value, fallback) => {
      const hour = Number(value);
      return Number.isInteger(hour) && hour >= 0 && hour <= 23 ? hour : fallback;
    };

    const formatYen = (subunits) => `${yenFormatter.format(Math.max(0, Math.ceil(Number(subunits || 0) / 100)))}円`;

    const updateAnnouncementGreetings = (root = document) => {
      root.querySelectorAll('[data-time-greeting-section]').forEach((section) => {
        const hour = new Date().getHours();
        const morningStart = readHour(section.dataset.morningStartHour, 5);
        const dayStart = readHour(section.dataset.dayStartHour, 11);
        const nightStart = readHour(section.dataset.nightStartHour, 18);
        let message = section.dataset.nightText;

        if (isWithinRange(hour, morningStart, dayStart)) {
          message = section.dataset.morningText;
        } else if (isWithinRange(hour, dayStart, nightStart)) {
          message = section.dataset.dayText;
        }

        if (!message) return;

        section.querySelectorAll('[data-announcement-greeting-message]').forEach((element) => {
          element.textContent = message;
        });
      });
    };

    const setFreeShippingHeaderOffset = (height = 0) => {
      document.documentElement.style.setProperty('--free-shipping-bar-offset', `${height}px`);
    };

    const updateFreeShippingStickyState = (wrapper) => {
      const bar = wrapper.querySelector('[data-free-shipping-bar]');

      if (!bar || wrapper.classList.contains('is-hidden')) {
        wrapper.classList.remove('is-sticky');
        wrapper.style.removeProperty('--free-shipping-bar-height');
        setFreeShippingHeaderOffset();
        return;
      }

      const barHeight = bar.getBoundingClientRect().height;
      const isSticky = wrapper.getBoundingClientRect().top <= 0;
      wrapper.style.setProperty('--free-shipping-bar-height', `${barHeight}px`);
      wrapper.classList.toggle('is-sticky', isSticky);
      setFreeShippingHeaderOffset(isSticky ? barHeight : 0);
    };

    const updateAllFreeShippingStickyStates = () => {
      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(updateFreeShippingStickyState);
    };

    const updateFreeShippingBars = (root = document, cartData = null) => {
      root.querySelectorAll('[data-free-shipping-bar]').forEach((bar) => {
        const wrapper = bar.closest('[data-free-shipping-wrapper]');
        const messageElement = bar.querySelector('[data-free-shipping-message]');
        const threshold = Number(bar.dataset.freeShippingThreshold);
        const itemCount = Number(cartData?.item_count ?? bar.dataset.freeShippingItemCount ?? 0);
        const totalPrice = Number(cartData?.total_price ?? bar.dataset.freeShippingTotalPrice ?? 0);

        if (!wrapper || !messageElement || !Number.isFinite(threshold) || threshold <= 0) return;

        bar.dataset.freeShippingItemCount = String(itemCount);
        bar.dataset.freeShippingTotalPrice = String(totalPrice);

        if (itemCount > 0 && totalPrice >= threshold) {
          wrapper.classList.add('is-hidden');
          updateFreeShippingStickyState(wrapper);
          return;
        }

        if (itemCount === 0) {
          messageElement.textContent = (bar.dataset.freeShippingEmptyText || '[threshold]以上のお買い上げで送料無料です').replace(
            '[threshold]',
            formatYen(threshold)
          );
        } else {
          messageElement.textContent = (bar.dataset.freeShippingRemainingText || 'あと[amount]で送料が無料になります').replace(
            '[amount]',
            formatYen(threshold - totalPrice)
          );
        }

        wrapper.classList.remove('is-hidden');
        updateFreeShippingStickyState(wrapper);
      });
    };

    const fetchCartForFreeShipping = async () => {
      try {
        const cartUrl = window.routes?.cart_url || '/cart';
        const response = await fetch(cartUrl.endsWith('.js') ? cartUrl : `${cartUrl}.js`, { credentials: 'same-origin' });
        if (!response.ok) return;
        updateFreeShippingBars(document, await response.json());
      } catch (error) {
        return;
      }
    };

    let cartUpdateSubscriptionBound = false;
    let cartUpdatedDomListenerBound = false;

    const bindCartUpdates = () => {
      if (!cartUpdateSubscriptionBound && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event?.cartData?.total_price !== undefined) {
            updateFreeShippingBars(document, event.cartData);
            return;
          }

          fetchCartForFreeShipping();
        });
        cartUpdateSubscriptionBound = true;
      }

      if (!cartUpdatedDomListenerBound) {
        document.addEventListener('cart:updated', fetchCartForFreeShipping);
        cartUpdatedDomListenerBound = true;
      }
    };

    const requestStickyUpdate = () => window.requestAnimationFrame(updateAllFreeShippingStickyStates);

    updateAnnouncementGreetings();
    updateFreeShippingBars();
    bindCartUpdates();
    document.addEventListener('DOMContentLoaded', bindCartUpdates, { once: true });
    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate);
    document.addEventListener('shopify:section:load', (event) => {
      updateAnnouncementGreetings(event.target);
      updateFreeShippingBars(event.target);
      requestStickyUpdate();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-table-of-contents"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-table-of-contents')) {
    customElements.define('faq-table-of-contents', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-faq-toc-list]');
        this.handleReady = () => this.render();
        this.handleSectionLoad = () => this.render();
        this.handleClick = (event) => this.openTarget(event);
        document.addEventListener('shopify:section:load', this.handleSectionLoad);
        this.addEventListener('click', this.handleClick);

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.handleReady, { once: true });
        } else {
          this.render();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.handleReady);
        document.removeEventListener('shopify:section:load', this.handleSectionLoad);
        this.removeEventListener('click', this.handleClick);
      }

      render() {
        if (!this.list) return;

        const sources = document.querySelectorAll('#MainContent .collapsible-content');
        const fragment = document.createDocumentFragment();
        let headingCount = 0;

        sources.forEach((source) => {
          const sectionHeading = source.querySelector('.collapsible-content__heading');
          const headingText = sectionHeading ? sectionHeading.textContent.trim() : '';
          const headingId = sectionHeading ? sectionHeading.id : '';
          if (!headingText || !headingId) return;

          const item = document.createElement('li');
          const link = document.createElement('a');
          item.className = 'faq-toc__item';
          link.textContent = headingText;
          link.href = '#' + headingId;
          item.append(link);
          fragment.append(item);
          headingCount += 1;
        });

        this.list.replaceChildren(fragment);
        this.hidden = headingCount === 0;
      }

      openTarget(event) {
        const link = event.target.closest('a[href^="#"]');
        if (!link || !this.contains(link)) return;

        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (target && target.tagName === 'DETAILS') target.open = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-custom-5icons"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.searchSuggests = this.querySelectorAll('search-suggest');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.isSearchSuggestOpen()) return;

      const headerBottom = (this.headerBounds.top || 0) + this.header.offsetHeight;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= (this.headerBounds.top || 0)) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('logo-hidden');
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.remove('logo-hidden');
        return;
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.remove('logo-hidden');
        return;
      }
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    isSearchSuggestOpen() {
      // おすすめキーワードパネル(search-suggest)が開いている間はヘッダーのスクロール処理を止める
      if (!this.searchSuggests) return false;
      return Array.from(this.searchSuggests).some((element) => element.isOpen);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // カスタムヘッダーは検索モーダル(details-modal)を描画しないため null ガード
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const headerBottom = (this.headerBounds.top || 0) + this.header.offsetHeight;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= (this.headerBounds.top || 0)) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('logo-hidden');
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.remove('logo-hidden');
        return;
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.remove('logo-hidden');
        return;
      }
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
